import React from 'react';
import { TopBanner } from '../components/TopBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Pricing } from '../components/Pricing';
export function Plans() {
  return <div className="min-h-screen bg-white dark:bg-[#000000] text-[#333333] dark:text-gray-100 transition-colors duration-300" data-id="element-751" data-mp="1mt5m9acbez8v">
      <TopBanner data-id="element-752" data-mp="1hyrq35ptwo35" />
      <Navbar data-id="element-753" data-mp="1wps8o3kahyd0" />
      <main className="pt-[133px]" data-id="element-754" data-mp="1wp8wz4l8g67f">
        <div className="py-20 text-center bg-[#13E200] dark:bg-[#090D1A]" data-id="element-755" data-mp="1wo7ck9ibu7d1">
          <h1 className="text-5xl font-black tracking-tighter text-black dark:text-white uppercase" data-id="element-756" data-mp="1rpma03flrblf">
            Our Plans
          </h1>
        </div>
        <Pricing data-id="element-757" data-mp="25o46oqnhjyfh" />
      </main>
      <Footer data-id="element-758" data-mp="21obve66pje6f" />
    </div>;
}